export default __webpack_public_path__ + "static/media/seven.e0d77826.jpeg";